import { CheckOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getPageContentPrice } from '../../../../entities/PageContent'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './PriceSection.module.scss'

const PriceSection: React.FC = () => {
    const { t, i18n } = useTranslation()
    const priceSection = useSelector(getPageContentPrice)
    const fallbackIncluded = t('price.included', {
        returnObjects: true
    }) as string[]
    const lang = i18n.language.split('-')[0]
    const isRu = lang === 'ru'

    const title = priceSection
        ? isRu
            ? priceSection.titleRu
            : priceSection.titleEn
        : t('price.title')
    const amount = priceSection?.amount ?? 90
    const currency = priceSection?.currency ?? '$'
    const perDayText = priceSection
        ? isRu
            ? priceSection.perDayTextRu
            : priceSection.perDayTextEn
        : t('price.perDay')
    const depositText = priceSection
        ? isRu
            ? priceSection.depositTextRu
            : priceSection.depositTextEn
        : t('price.deposit')
    const included =
        priceSection?.items?.map((item) =>
            isRu ? item.textRu : item.textEn
        ) ?? fallbackIncluded

    return (
        <PageSection
            title={title}
            style={{ backgroundColor: 'var(--bg-base)' }}
        >
            <div className={cls.card}>
                <div className={cls.priceRow}>
                    <span className={cls.currency}>{currency}</span>
                    <span className={cls.amount}>{amount}</span>
                    <span className={cls.period}>/{perDayText}</span>
                </div>
                <p className={cls.deposit}>{depositText}</p>
                <hr className={cls.divider} />
                <ul className={cls.list}>
                    {included.map((item) => (
                        <li key={item} className={cls.listItem}>
                            <span className={cls.listCheck} aria-hidden>
                                <CheckOutlined />
                            </span>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </PageSection>
    )
}

export default PriceSection
